module.exports = __webpack_public_path__ + "img/20210720_185039.3a359f25.jpg";